module.exports = __webpack_public_path__ + "create/static/media/icon.a23d2b88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/v3/Form/icon.svg
// module id = 535
// module chunks = 39